module.exports = __webpack_public_path__ + "img/LT112046572.741f3e14.png";